import { UpperCasePipe } from '@angular/common'
import { Component, inject, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { DialogService } from '../../../../services/dialog/dialog.service'
import type { SupportedLanguage } from '../../../../services/internationalization.service'
import { InternationalizationService } from '../../../../services/internationalization.service'

@Component({
  selector: 'dhp-language-modal',
  templateUrl: './language-modal.component.html',
  imports: [UpperCasePipe, TranslatePipe],
})
export class LanguageModalComponent {
  dialogService = inject(DialogService)
  private i18Service = inject(InternationalizationService)

  readonly currentLanguage = input<SupportedLanguage>('nl')
  readonly languageChange = output<SupportedLanguage>()

  closeLanguageModal(): void {
    this.dialogService.toggle('language', false)
  }

  selectLanguage(lang: SupportedLanguage): void {
    this.languageChange.emit(lang)
    this.closeLanguageModal()
  }

  enabledLanguages(): SupportedLanguage[] {
    return this.i18Service.enabledLanguages()
  }
}
